<template>
  <div :style="useProps">
    <div v-if="loading" class="loading"></div>
    <div ref="container" v-mutate="recalculateHeight" class="expansion-effect">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Container',
  props: {
    width: {type: String},
    maxWidth: {type: String},
    verticalExpansion: {type: Boolean, default: true},
    timeOut: {type: Number, default: 0},
    loading: {type: Boolean}
  },

  computed: {
    useProps () {
      const style = ''
      if (this.width) style += `width: ${this.width};`
      if (this.maxWidth) style += `max-width: ${this.width};`
      return style
    }
  },

  mounted () {
    this.recalculateHeight()
  },

  methods: {
    recalculateHeight () {
      const container = this.$refs.container
      if (this.verticalExpansion) {
        setTimeout(() => {
          if (container) {
            const newHeight = this.calculateElementInnerHeight(container)
            container.style.height = `${newHeight}px`
          }
        }, this.timeOut)
      }
    },

    calculateElementInnerHeight(element) {
      const children = element.children
      let childrenHeight = 0

      if (children) {
        for (let i = 0; i < children.length; i++) {
          childrenHeight += children[i].scrollHeight

          // Calculate margin top-bottom for each child
          let [mtValue, mbValue, mbPreviousValue] = [0, 0, 0]
          let mbPrevious = ''
          
          if (i > 0) mbPrevious = window.getComputedStyle(children[i - 1]).marginBottom
          
          const [mt, mb] = [window.getComputedStyle(children[i]).marginTop, window.getComputedStyle(children[i]).marginBottom]

          if (mbPrevious.includes('px')) mbPreviousValue = Number(mbPrevious.split('px')[0])
          if (mt.includes('px')) {
            mtValue = Number(mt.split('px')[0])
            if (i > 0) {
              childrenHeight += mtValue
              childrenHeight -= mtValue > mbPreviousValue ? mbPreviousValue : 0
            }
          }
          if (mb.includes('px')) {
            mbValue = Number(mb.split('px')[0])
            childrenHeight += mbValue
          }
          // console.log(`Elemento altura: ${children[i].scrollHeight}, marginTop: ${mtValue}, marginBottom: ${mbValue}`)
        }
      }
      return childrenHeight
    }
  }
}
</script>

<style scoped>
.loading {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 999;
}

.expansion-effect {
  transition: height 0.3s ease;
}
</style>


